import { Card, Grid, Icon, Typography } from '@mui/material';
import DropboxChooser from './cloud/DropboxChooser';
import GoogleDrivePicker from './cloud/GoogleChooser';
import OneDriveChooser from './cloud/OneDriveChooser';
import { useFeatureFlags } from 'src/contexts/FeatureFlagsContext';
import { FeatureFlags } from 'src/flags';

export const MediaCloudIntegration = ({
  props,
}: {
  props: {
    handleUrlUpload: (urls: string[]) => void;
    onFilesReceived?: (files: File[]) => void;
    onProcessingStart?: (count: number) => void;
  };
}) => {
  const { hasFeature } = useFeatureFlags();

  return (
    <Grid
      container
      gap={2}
      sx={{
        p: 2,
        alignItems: 'center',
      }}
    >
      {hasFeature(FeatureFlags.NGW_MEDIA_CLOUD_PROVIDER_DROPBOX) && (
        <Card
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <DropboxChooser
            onProcessingStart={props.onProcessingStart}
            success={(files: any) => {
              const links = files.map((file: any) => file.link);
              props.handleUrlUpload(links);
            }}
          ></DropboxChooser>
        </Card>
      )}
      {hasFeature(FeatureFlags.NGW_MEDIA_CLOUD_PROVIDER_GOOGLE) && (
        <Card
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <GoogleDrivePicker
            onProcessingStart={props.onProcessingStart}
            onFilesReceived={props.onFilesReceived}
          >
            <Icon sx={{ width: 32, height: 32 }}>
              <img alt={'Google'} src={'/icons/GoogleDriveIcon.svg'} />
            </Icon>
            <Typography>Google Drive</Typography>
          </GoogleDrivePicker>
        </Card>
      )}
      {hasFeature(FeatureFlags.NGW_MEDIA_CLOUD_PROVIDER_ONEDRIVE) && (
        <Card
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <OneDriveChooser
            onProcessingStart={props.onProcessingStart}
            onFilesReceived={props.onFilesReceived}
          >
            <Icon sx={{ width: 32, height: 32 }}>
              <img alt={'OneDrive'} src={'/icons/OneDriveIcon.svg'} />
            </Icon>
            <Typography>OneDrive</Typography>
          </OneDriveChooser>
        </Card>
      )}
    </Grid>
  );
};
